import { useCallback } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";

import makeItAnArray from "./makeItAnArray";
import { addUrlParam, removeUrlParams } from "./urlParamTools";

const useUserID = () => {
  let match = useRouteMatch("*/user/:userID");
  return Number(match?.params?.userID);
};

const useRemoveUrlParams = () => {
  const history = useHistory();
  const location = useLocation();

  return useCallback(
    (...params) => {
      removeUrlParams(makeItAnArray(params).flat());
      const { search } = window.location;
      history.push(`${location.pathname}${search}`);
    },
    [history, location]
  );
};

const useAddUrlParam = () => {
  const history = useHistory();

  return useCallback(
    (param, value) => {
      addUrlParam(param, value);
      const { search } = window.location;
      history.push(`${window.location.pathname}${search}`);
    },
    [history]
  );
};

export { useUserID, useAddUrlParam, useRemoveUrlParams };
